<template>
  <div>

    <div class="row">

      <div class="col-auto">
        <label for="select-city">Comune</label>
        <select id="select-city" name="Comune" class="custom-select" v-model="filters.city" :disabled="isLoading"
          @change="onSelectCity()">
          <option :value="undefined" key="-1">-</option>
          <option v-for="row in this.data.cities" :value="row" :key="row">
            {{ row }}
          </option>
        </select>
      </div>

      <div class="col-auto">
        <label for="select-type">Tipologia</label>
        <select id="select-type" name="Tipologia" class="custom-select" v-model="filters.type" :disabled="isLoading"
          @change="onSelectType()">
          <option :value="undefined" key="-1">-</option>
          <option v-for="row in this.data.types" :value="row" :key="row">
            {{ row }}
          </option>
        </select>
      </div>

      <div class="col-auto">
        <label>Azioni</label>
        <div class="btn-toolbar mr-2" role="toolbar" aria-label="Bottoni azione">
          <div class="btn-group mb-2 mr-2" role="group" aria-label="Azioni">
            <button class="btn btn-primary" @click="onSubmitFilters()" :disabled="!isFiltersSelected">
              <i class="ti ti-filter"></i> Carica
            </button>
            <button class="btn btn-default" @click="onCancelFilters()" v-if="isFiltersSelected && isPopulated">
              <i class="ti ti-arrow-circle-up"></i>
              Annulla
            </button>
          </div>
        </div>
      </div>

    </div>

    <div class="row" v-show="isPopulated && !isEmpty">
      <div class="container">

        <div id="heatmap-stats-legend">
          <div class="row justify-content-center">
            <div class="col col-auto text-center p-3 m-3 border" style=" background: #fff;">

              <div style="display: flex; justify-content: center; align-items: center;"
                v-if="this.data.weights.steps && this.data.weights.steps.length > 0">
                <div v-for="(step, s) in this.data.weights.steps" :key="s">
                  <label class="mt-0 mb-2" style="font-size: 16px; font-weight: 900;">{{ step }}</label>
                  <div class="p-3" :style="heatmapStylizeStepLegend(s)">&nbsp;</div>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="card" v-show="isPopulated">

      <div id="heatmap-stats" @mousedown="heatmapMouseDownHandler">
        <vue-good-table title="Valutazioni" styleClass="vgt-table" :columns="table.columns" :rows="data.rates"
          :sort-options="{ enabled: false }" :isLoading="isLoading">

          <div slot="emptystate" id="emptystate" v-if="this.data.rates.length === 0">
            <div class="vgt-center-align vgt-text-disabled">
              <span v-if="!isLoading">Nessun risultato disponibile</span>
            </div>
          </div>

          <template slot="table-row" slot-scope="props">

            <div v-if="props.column.field === 'name'">
              <div style="padding: .75em .75em .75em .75em; " class="text-overflow-name" :title="props.row.name">
                {{ props.row.name }}
              </div>
            </div>

            <div v-else>
              <div :style="heatmapStylizeRateRow(props)" :title="heatmapSanitizeRateTitle(props)">
                <div class="text-overflow-rate-value">
                  {{ props.row.rates[props.column.field.replace("rates.", "")].v }}
                </div>
                &nbsp; <!-- css:important! -->
              </div>
            </div>

          </template>

        </vue-good-table>
      </div>

    </div>

  </div>
</template>

<style lang="css">
#heatmap-stats table th:first-child,
#heatmap-stats table td:first-child {
  position: sticky;
  left: 0;
  z-index: 9999;
}

/* #heatmap-stats table th:last-child,
#heatmap-stats table td:last-child {
  position: sticky;
  right: 0;
  z-index: 9999;
} */

#heatmap-stats table td {
  border-right: 2px solid #DCDFE6;
}

#heatmap-stats table td:last-child {
  border-right: 0px;
}

#heatmap-stats table td:first-child {
  overflow: hidden;
}

/* #heatmap-stats table td:last-child {
  overflow: hidden;
} */

#heatmap-stats .text-overflow-cell {
  overflow: hidden;
  max-width: 250px;
}

#heatmap-stats .text-overflow-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: #fff;
}

#heatmap-stats .text-overflow-rate-value {
  position: absolute;
  font-size: 16px;
  font-weight: 500;
}
</style>

<script>
import axios from "axios";

export default {

  components: {

  },

  data() {
    return {

      isLoading: false,
      isPopulated: false,

      filters: {
        city: undefined,
        type: undefined
      },

      loaders: {
        rates: false,
        cities: false,
        types: false
      },

      data: {
        weights: {},
        rates: [],
        cities: [],
        types: []
      },

      table: {
        columns: [
          {
            label: "",
            field: "name",
            thClass: "p-2",
            tdClass: "p-0 m-0 text-overflow-cell"
          },
          {
            label: "ECCELLENTE",
            field: "rates.5",
            thClass: "text-center p-2",
            tdClass: "text-center p-0 m-0",
            width: "216px",
            html: true
          },
          {
            label: "MOLTO BUONO",
            field: "rates.4",
            thClass: "text-center p-2",
            tdClass: "text-center p-0 m-0",
            width: "216px",
            html: true
          },
          {
            label: "NELLA MEDIA",
            field: "rates.3",
            thClass: "text-center p-2",
            tdClass: "text-center p-0 m-0",
            width: "216px",
            html: true
          },
          {
            label: "SCARSO",
            field: "rates.2",
            thClass: "text-center p-2",
            tdClass: "text-center p-0 m-0",
            width: "216px",
            html: true
          },
          {
            label: "PESSIMO",
            field: "rates.1",
            thClass: "text-center p-2",
            tdClass: "text-center p-0 m-0",
            width: "216px",
            html: true
          }
        ],
        position: {
          top: 0,
          left: 0,
          x: 0,
          y: 0
        }
      }

    };
  },

  computed: {
    isFiltersSelected() {
      return (
        this.filters.city !== undefined
        || this.filters.type !== undefined
      );
    },
    isEmpty() {
      return (this.data.rates.length === 0);
    }
  },

  methods: {

    loadData(city, type) {
      if (
        city === undefined
        && type === undefined
      ) return;

      const self = this;
      self.isLoading = true;

      const qs = [
        ...(city) ? ['city=' + city] : [],
        ...(type) ? ['type=' + type] : []
      ].join('&');

      axios({
        method: "get",
        url: `${self.$url}tourism/stats/rates?${qs}`,
        headers: this.$config.axiosHeaders(),
      })
        .then(function (response) {
          self.$set(self.data, "weights", response.data.weights);
          self.$set(self.data, "rates", response.data.rates);
          console.log('loadData', self.data.weights, self.data.rates);
        })
        .catch(function (error) {
          self.$processError(error);
        })
        .finally(function () {
          self.isLoading = false;
          self.isPopulated = true;
        });
    },

    loadCities() {
      const self = this;
      axios({
        method: "get",
        url: `${self.$url}tourism/stats/ui/cities`,
        headers: this.$config.axiosHeaders(),
      })
        .then(function (response) {
          self.$set(self.data, "cities", response.data.cities);
          console.log('loadCities', self.data.cities);
        })
        .catch(function (error) {
          self.$processError(error);
        });
    },

    loadTypes() {
      const self = this;
      axios({
        method: "get",
        url: `${self.$url}tourism/stats/ui/types`,
        headers: this.$config.axiosHeaders(),
      })
        .then(function (response) {
          self.$set(self.data, "types", response.data.types);
          console.log('loadTypes', self.data.types);
        })
        .catch(function (error) {
          self.$processError(error);
        });
    },

    onSelectCity() {
      this.$emit("input", this.filters.city);
      (!this.isFiltersSelected && !this.isEmpty)
        && this.cancelResources();
    },

    onSelectType() {
      this.$emit("input", this.filters.type);
      (!this.isFiltersSelected && !this.isEmpty)
        && this.cancelResources();
    },

    onSubmitFilters() {
      this.updateResources();
    },

    onCancelFilters() {
      this.$set(this.filters, "city", undefined);
      this.$set(this.filters, "type", undefined);
      this.cancelResources();
    },

    updateResources() {
      this.loadData(this.filters.city, this.filters.type);
    },

    cancelResources() {
      this.isPopulated = false;
      this.$set(this.data, "resume", {});
      this.$set(this.data, "resume_by_types", {});
      this.$set(this.data, "rates", []);
    },

    heatmapStylizeStepLegend(step) {
      const style = ""
        + " width: 75px;"
        + " background-color: rgb(131, 40, 53, " + (1.0 - (step * 0.1)) + ");"
      return style;
    },

    heatmapStylizeRateRow(props) {
      const field = props.column.field.replace("rates.", "");
      const opacity = parseFloat(props.row.rates[field].w);
      const style = ""
        + " display: flex;"
        + " justify-content: center;"
        + " align-items: center;"
        + " padding: .75em .75em .75em .75em;"
        + " background-color: rgb(131, 40, 53, " + opacity + ");"
        + ((opacity >= 0.5) && " color: #fff;");
      return style;
    },

    heatmapSanitizeRateTitle(props) {
      const field = props.column.field.replace("rates.", "");
      return field.toUpperCase() + ": " + props.row.rates[field].v;
    },

    heatmapMouseDownHandler(e) {

      // scrollable table element
      const table = document
        .getElementById("heatmap-stats")
        .getElementsByClassName("vgt-responsive")[0];

      // change the cursor and prevent user from selecting the text
      table.getElementsByTagName("tr").forEach(tr => {
        tr.style.cursor = 'grabbing';
        tr.style.userSelect = 'none';
      });

      // set current table position
      this.$set(this.table, "position", {
        // current scroll
        left: table.scrollLeft,
        top: table.scrollTop,
        // current mouse position
        x: e.clientX,
        y: e.clientY,
      });

      // add mouse handlers
      document.addEventListener('mousemove', this.heatmapMouseMoveHandler);
      document.addEventListener('mouseup', this.heatmapMouseUpHandler);

    },

    heatmapMouseMoveHandler(e) {

      // how far the mouse has been moved
      const dx = e.clientX - this.table.position.x;
      const dy = e.clientY - this.table.position.y;

      // scrollable table element
      const table = document
        .getElementById("heatmap-stats")
        .getElementsByClassName("vgt-responsive")[0];

      // scroll the element
      table.scrollTop = this.table.position.top - dy;
      table.scrollLeft = this.table.position.left - dx;

      // // let direction = "";
      // // // if (e.movementY > 0 && e.movementX == 0) {
      // // //   direction = "down";
      // // // } else if (e.movementY < 0 && e.movementX == 0) {
      // // //   direction = "up";
      // // // } else if (e.movementX > 0 && e.movementY == 0) {
      // // //   direction = "right";
      // // // } else if (e.movementX < 0 && e.movementY == 0) {
      // // //   direction = "left";
      // // // }
      // // if((e.movementY < 0 && e.movementX == 0) || (e.movementY > 0 && e.movementX == 0)) {
      // //   direction = "up & down";
      // // } else if((e.movementX < 0 && e.movementY == 0) || (e.movementX > 0 && e.movementY == 0)) {
      // //   direction = "left & right";
      // // }
      // const direction = ((e.movementY < 0 && e.movementX == 0) || (e.movementY > 0 && e.movementX == 0))
      // ? "up & down" : ((e.movementX < 0 && e.movementY == 0) || (e.movementX > 0 && e.movementY == 0))
      // ? "left & right" : undefined;
      // if(direction) {
      //   console.log("direction", direction);
      // }

    },

    heatmapMouseUpHandler() {

      // remove mouse handlers
      document.removeEventListener('mousemove', this.heatmapMouseMoveHandler);
      document.removeEventListener('mouseup', this.heatmapMouseUpHandler);

      // scrollable table element
      const table = document
        .getElementById("heatmap-stats")
        .getElementsByClassName("vgt-responsive")[0];

      // cleanup style
      table.getElementsByTagName("tr").forEach(tr => {
        tr.style.removeProperty('cursor');
        tr.style.removeProperty('user-select');
      });

    }

  },

  async created() {
    console.log('RatesStats::created');
  },

  async mounted() {
    console.log('RatesStats::mounted');
    this.loadCities();
    this.loadTypes();
  }

};
</script>
